module.exports = __webpack_public_path__ + "img/payment_deferral_icon.6eba670d.svg";